import React from 'react';
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import StudentDetail from './StudentDetail';
import Logs from './Logs';
import { logsValueMapping } from './constant';

const ViewStudentTransferDetail=({details})=>{
const getLogsValueMapping=(logs)=>{
 return (logs??[]).map(item=>{
  const value= logsValueMapping?.[item?.title]=='updatedBy'
  ?item?.[logsValueMapping?.[item?.title]]
  :`PSID: ${item?.[logsValueMapping?.[item?.title]]}`
    return {...item,value:value}
})
}
    return(
      <>
      <StudentDetail details={details?.details}/>
      <Logs rowList={getLogsValueMapping(details?.logs)}/>
      </>
    );

}
export default ViewStudentTransferDetail